// utils
import { fetcher, endpoints, poster, patcher } from '../utils/axios';

/**
 * Creates a new user.
 * @param {Object} payload - The object containing the user's information to add.
 * @param {string} payload.name - The name of the user.
 * @param {string} [payload.email] - The email address of the user.
 * @param {string} [payload.phone_number] - The phone number of the user.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */
export async function createUser(payload){
    const URL = endpoints.profile.createUser
    return await poster([URL,payload])
}
/**
 * Deletes a user from the database.
 * @param {Object} payload - The object containing the user's ID to delete.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */
export async function removeUser(payload){
    const URL = endpoints.profile.removeUser
    return await poster([URL,payload])
}

/**
 * Resends an OTP to the user.
 * @param {Object} payload - The object containing the user's details needed to resend the OTP.
 * @returns {Promise} - A promise that resolves or rejects based on the response from the server.
 */

export async function resendOTP(payload) {
    const URL = endpoints.profile.resendOTP;
    return await fetcher([URL, {params:payload}])
}